import React, { Component } from 'react';

export default class TopBar extends Component {

    render() {
        return (
            <div className="top-bar light-blue visible-md visible-lg">
                <div className="container">
                    <div className="row">
                        { /** Social Icon **/}
                        <div className="col-md-6">
                            { /** Social Icon **/}
                            <ul className="list-inline social-top tt-animate btt">
                                <li>
                                    <a href="http://facebook.com.br/fcsistema.com.br">
                                        <i className="fa fa-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/FC_Sistema">
                                        <i className="fa fa-twitter"></i>
                                    </a>
                                </li>
                                {/* <li>
                                    <a href="#">
                                        <i className="fa fa-tumblr"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i className="fa fa-linkedin"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i className="fa fa-dribbble"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i className="fa fa-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="#">
                                        <i className="fa fa-rss"></i>
                                    </a>
                                </li> */}
                            </ul>
                        </div>

                        <div className="col-md-6 text-right">
                            <ul className="topbar-cta no-margin">
                                <li className="mr-20">
                                    <a href="mailto:contato@fcsistema.com.br">
                                        <i className="material-icons mr-10">&#xE0B9;</i>contato@fcsistema.com.br</a>
                                </li>
                                <li>
                                    <a>
                                        <i className="material-icons mr-10">&#xE0CD;</i> (16) 99242-6932 / (16) 99113-6949</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    { /** /.row **/}
                </div>
                {/** /.container **/}
            </div >
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/TopBar.js